module.exports = __webpack_public_path__ + "img/icon_map_7_on_101.60b36bbf.png";